import styled from 'styled-components'

export const PermitsFiltersContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  margin-top: 32px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const FilterDropdown = styled.div<{ $active?: boolean }>`
  position: relative;
  flex: 1;
  min-width: 150px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const FilterDropdownTrigger = styled.button<{ $active?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-align: left;

  &:hover {
    border-color: #999999;
    background-color: #f8f8f8;
  }

  ${({ $active }) =>
    $active &&
    `
    border-color: #00ade6;
    box-shadow: 0 0 0 3px rgba(0, 173, 230, 0.1);
  `}
`

export const FilterDropdownArrow = styled.svg`
  width: 12px;
  height: 12px;
  color: #6b6b6b;
  transition: transform 0.2s;
  flex-shrink: 0;
`

export const FilterDropdownMenu = styled.div<{ $active?: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  visibility: ${({ $active }) => ($active ? 'visible' : 'hidden')};
  transform: translateY(${({ $active }) => ($active ? '0' : '-10px')});
  transition: all 0.2s;
  z-index: 100;
  max-height: 320px;
  overflow-y: auto;

  @media (max-width: 768px) {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    border-radius: 12px 12px 0 0;
    max-height: 70vh;
    transform: translateY(${({ $active }) => ($active ? '0' : '100%')});
  }
`

export const FilterDropdownHeader = styled.div`
  padding: 12px 16px;
  background: #f8f8f8;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999999;
`

export const FilterDropdownSection = styled.div`
  padding: 8px 0;
`

export const FilterDropdownSectionTitle = styled.div`
  padding: 8px 16px 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999999;
`

export const FilterDropdownOption = styled.div<{ $selected?: boolean }>`
  padding: 10px 16px;
  font-size: 13px;
  color: ${({ $selected }) => ($selected ? '#00ade6' : '#1a1a1a')};
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
  font-weight: ${({ $selected }) => ($selected ? 500 : 400)};

  &:hover {
    background: #f8f8f8;
  }

  ${({ $selected }) =>
    $selected &&
    `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: #00ade6;
    }
  `}
`

export const FilterDropdownOptionMain = styled.span`
  display: block;
  margin-bottom: 2px;
`

export const FilterDropdownOptionDesc = styled.span`
  font-size: 12px;
  color: #6b6b6b;
  font-weight: 400;
`

export const FilterMoreBtn = styled.button`
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #00ade6;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  &:hover {
    background: rgba(0, 173, 230, 0.1);
    border-color: #00ade6;
  }

  svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
  }
`

export const PermitsSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8f8f8;
  border-radius: 6px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`

export const PermitsCount = styled.div`
  font-size: 13px;
  color: #6b6b6b;

  strong {
    color: #1a1a1a;
    font-weight: 600;
  }
`

export const PermitsSort = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6b6b6b;

  select {
    border: none;
    background: none;
    color: #00ade6;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
  }

  button {
    background: none;
    border: none;
    color: #00ade6;
    cursor: pointer;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }
`
